import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import overa from "../../../assets/images/overa.svg";
import redTick from "../../../assets/images/redTick.svg";
import greenTick from "../../../assets/images/greenTick.svg";
import {
  AccordionDetails,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Alert,
} from "@mui/material";
import { ErrorMessage } from "@hookform/error-message";
import CustomRadioButton from "../../common/InputComponents/CustomRadioButton";
import NoDocReasonRadioButtons from "../../common/InputComponents/NoDocReasonRadioButtons";
import InputField2 from "../../common/InputComponents/InputField2";
import DragDropDocumentButton from "../components/DragDropDocumentButton";
import AlertDialog from "../../common/AlertDialog";
import FormInstruction from "../../common/FormInstruction";
import FilePreview from "../../common/FilePreview";
import { DocumentSourceActionStrip } from "../documentMoveContext";
import CustomPreviewUpload from "../../common/CustomPreviewUpload";
import { useMutation } from "react-query";
import { useDataProvider, useGetIdentity, useNotify, usePermissions, useRefresh } from "react-admin";
import ShowDocumentStatus from "../components/ShowDocumentStatus";
import ReviewPendingTile from "../components/ReviewPendingTile";
import { RootState } from "../../../Store/store";
import AddDocuverusComment from "../Modals/AddDocuverusComment";
import ShowComments from "../components/ShowComments";
import InputSSNField from "../../common/InputComponents/InputSSNField";
import { checkModuleAccess, isSuperAdmin } from "../../../Functions/permissions";
import ssn_masked_placeholder from '../../../assets/images/ssn_masked_placeholder.jpg';
import InfoIcon from "@mui/icons-material/Info";
import PrintSSField from "../../common/InputComponents/PrintSSNField";
import { useUserRole } from "../../../ContextApi/UserRoleContext";
import { getSsnCreatedAt } from "./getSsnCreatedAt";
import { isDocumentReviewed, shouldShowReviewPending } from "../../../utils/screeningScore";

const SsnSection = (props) => {
  const {role} = useUserRole();
  const [ssnInformation, setSnnInformation] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const userRoleRedux = useSelector((state: RootState) => state.users.role);
  const userRole = role || userRoleRedux;
  const [deleteSSN, setDeleteSSN] = React.useState(false);

  const { register, watch, getValues, trigger, formState, setValue } = useFormContext();

  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const { mutate } = useMutation(
    "delete_document_ssn_document",
    (id) => dataProvider.deleteDocument(id),
    {
      onSuccess: (data) => {
        refresh();
        notify("Document deleted successfully...", {
          type: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        setDeleteSSN(false);
        setValue("ssn_data.file", "");
        setValue("ssn_data.file_image", "");
        setValue("ssn_data.availableToUpload_ssn", "No");
        setFilePreview({
          ssn_id: "",
          ssn_filePath: "",
        });
        props?.handleAPIDebounced();
      },
      onError: (data) => {
        alert("Fail deleting document");
        setDeleteSSN(false);
      },
      onMutate: () => {
        notify("Document is Deleting...", {
          type: "info",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      },
    }
  );

  const deleteDocumentHandler = (id) => {
    mutate(id);
  };

  useEffect(() => {
    //
    const subscribe: any = watch((value, { name, type }) => {
      //
      if (type === "change" && name === `ssn_data.isUS_citizen`) {
        trigger("ssn_data.SSNNumber");
      }
    });
    return () => subscribe.unsubscribe;
  }, [setValue, trigger, watch]);

  const [filePreview, setFilePreview] = useState({
    ssn_id: "",
    ssn_filePath: "",
  });
  const trn_id = props.Trnid; //useSelector((state: any) => state?.users?.userTrnId);

  const getSrcfromStatus = (socrValue) => {
    if (socrValue) {
      switch (Number(socrValue)) {
        case 1:
          return greenTick;
        case 2:
          return redTick;
        case 3:
          return overa;
      }
    } else {
      return overa;
    }
  };

  const getBlockStyleFromStatus = (socrValue) => {
    if (socrValue) {
      switch (Number(socrValue)) {
        case 1:
          return "p-1 block text-center rounded bg-success text-white";
        case 2:
          return "p-1 block text-center rounded bg-danger text-white";
        case 3:
          return "p-1 block text-center rounded bg-warning text-dark";
      }
    } else {
      return "p-1 block text-center rounded bg-warning text-dark";
    }
  };

  const { permissions } = usePermissions();
  const { data: getUserData } = useGetIdentity();
  const permissionToViewSSN = isSuperAdmin(checkModuleAccess(permissions, "View Docs", "View Proof of SSN"), getUserData?.userrole);
  const ssnData = watch("ssn_data");
  const ssnCreatedAt = getSsnCreatedAt(ssnData);
  const reviewPending = shouldShowReviewPending(
    isDocumentReviewed(ssnCreatedAt, props?.applicationStatusUpdatedOn),
    userRole
  );
  const ssnStatusValue = ssnData?.manualsocr
    ? ssnData?.manualsocr
    : ssnData?.calculatedscocr;
  const showSsnSoftStatus = Number(ssnStatusValue) === 3;
  const ssnOptionLabelOverrides = {
    2: "Document shows signs of editing",
    3: "No evidence of modification",
  };
  const ssnStatusOverrides = showSsnSoftStatus
    ? {
        statusLabelOverride: "No evidence of modification",
        statusIconOverride: (
          <InfoIcon style={{ fontSize: "18px" }} />
        ),
        statusClassOverride: "bg-info-soft text-info-soft text-center",
        optionLabelOverrides: ssnOptionLabelOverrides,
      }
    : { optionLabelOverrides: ssnOptionLabelOverrides };


  return (
    <AccordionDetails>
      <>
        <div className="ssn-t-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group cus-input-group mr-b30 mr-t30">
                <CustomRadioButton
                  label="Are you a US citizen?"
                  register={register("ssn_data.isUS_citizen")}
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-3 col-lg-3">
              <div className="emp-inputs">
                <div className="form-group cus-input-group mr-b30 print-hide">
                  <InputSSNField
                    placeholder={"SSN Number"}
                    notRequired={true}
                    label="SSN Number"
                    source={"ssn_data.SSNNumber"}
                    handleOnChange={() => {
                      props?.handleAPIDebounced();
                    }}
                  />
                </div>
                <div className="form-group cus-input-group mr-b30 d-none print-show">
                  <PrintSSField
                    placeholder={"SSN Number"}
                    label="SSN Number"
                    source={"ssn_data.SSNNumber"}
                  />
                </div>
              </div>
            </div>

            <div className="col-sm-12">
              <div className="i-a-block mb-2">
                <CustomRadioButton
                  onClick={() => {
                    if (!!watch("ssn_data?.file")) {
                      setDeleteSSN(true);
                    }
                  }}
                  notRequired={!props?.required}
                  disable={!!watch("ssn_data?.file")}
                  label="Do you have proof of SSN available?"
                  register={register("ssn_data.availableToUpload_ssn")}
                  handleOnChange={() => {
                    props?.handleAPIDebounced();
                  }}
                />
              </div>
            </div>

            {watch("ssn_data.availableToUpload_ssn") == "Yes" && (
              <>
                {watch("ssn_data")?.file && userRole != "applicant" && (
                  reviewPending ? (
                    <div className="pr-2">
                      <ReviewPendingTile
                        className={"col-lg col-sm-6 col-6 sub-aapl"}
                      />
                    </div>
                  ) : (
                  <div className="appl-status-wrap align-items-start">
                    <div className="d-flex flex-wrap">
                      {userRole === "Docuverus Super Admin" ? (
                        <div className="pr-2">
                          <ShowDocumentStatus
                            customWidth={240}
                            className={"col-lg col-sm-6 col-6 sub-aapl"}
                            trn_id={trn_id}
                            documentId={watch("ssn_data")?.documenttype_id}
                            SourceId={1}
                            value={ssnStatusValue}
                            src={getSrcfromStatus(
                              ssnStatusValue
                            )}
                            blockStyle={getBlockStyleFromStatus(
                              ssnStatusValue
                            )}
                            textStyle={""}
                            label={"Overall"}
                            invalidateQueries={"ssnGetidentification"}
                            statusLabelOverride={
                              ssnStatusValue == 2
                                ? "Document shows signs of editing"
                                : undefined
                            }
                            statusTopLabelOverride={
                              ssnStatusValue == 2 ? "Unverifiable" : undefined
                            }
                            {...ssnStatusOverrides}
                          />
                        </div>
                      ) : (
                        <div className="pr-2">
                          <ShowDocumentStatus
                            customWidth={240}
                            className={"col-lg col-sm-6 col-6 sub-aapl"}
                            trn_id={trn_id}
                            documentId={watch("ssn_data")?.documenttype_id}
                            SourceId={1}
                            value={ssnStatusValue}
                            src={getSrcfromStatus(
                              ssnStatusValue
                            )}
                            blockStyle={getBlockStyleFromStatus(
                              ssnStatusValue
                            )}
                            textStyle={""}
                            disable={true}
                            label={"Overall"}
                            invalidateQueries={"ssnGetidentification"}
                            statusLabelOverride={
                              ssnStatusValue == 2
                                ? "Document shows signs of editing"
                                : undefined
                            }
                            statusTopLabelOverride={
                              ssnStatusValue == 2 ? "Unverifiable" : undefined
                            }
                            {...ssnStatusOverrides}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  )
                )}


                <div className={`card-body`}>
                  {(watch("ssn_data")?.file != null && userRole === "Docuverus Super Admin" &&
                    (
                      <ShowComments
                        comment_heading="Docuverus Internal Comment"
                        section_comment={watch("ssn_data")?.InternalComment}
                        role={userRole}
                      />
                    ))}
                  {watch("ssn_data")?.file != null && (
                    <ShowComments
                      section_comment={watch("ssn_data")?.section_comment}
                      role={userRole}
                    />
                  )}

                  {watch("ssn_data")?.file != null && watch("ssn_data")?.section_comment?.["applicant"] && watch("ssn_data")?.section_comment?.["applicant"] !== "" && (
                    <ShowComments
                      section_comment={watch("ssn_data").section_comment}
                      role={userRole}
                      comment_heading="Applicant Comment"
                    />
                  )}
                </div>
                <div className="col-sm-12">
                  <div className={`row mb-2  sb-blue m-1`}>
                    <div
                      className={
                        filePreview.ssn_id !== ""
                          ? "col-md-8 col-sm-12 "
                          : "col-md-12 col-sm-12 "
                      }
                    >
                      <div className="sb-blue mx-3 m-1">
                        <div className="blue-flex">
                          <div className="row align-items-center px-2 print-hide">
                            <div
                              className="col-sm-12 col-md-10"
                              style={{
                                fontSize: "11px",
                                color: "#606060",
                                paddingLeft: "16px",
                              }}
                            >
                              <div className="d-flex align-items-center ">
                                <strong>
                                  {`${1}. ${"Proof of SSN "}`}:*&nbsp;
                                </strong>
                                <AlertDialog
                                  message={`Only upload clear, complete, straight documents.`}
                                />
                              </div>

                              <div className="d-flex align-items-center m-1">
                                <strong>(SSN card)</strong>
                              </div>
                              <FormInstruction
                                message={
                                  "Click the (i) button above for details"
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="d-flex flex-wrap mt-2">
                              {watch("ssn_data.file") == null ? (
                                <div className="">
                                  <DragDropDocumentButton
                                    SourceId={1}
                                    documentId={4}
                                    fetchRecord={() => { }}
                                    acceptedFiles={`image/*,application/pdf`}
                                    invalidateQueries={"otherDoc"}
                                    tag={`fileOprations_other_income`}
                                    trn_id={trn_id}
                                    fileError={false}
                                  />
                                </div>
                              ) : (
                                <div className="d-flex">
                                  <DocumentSourceActionStrip
                                    hasDropZone={false}
                                    scope={{ sectionKey: "ssn", sourceId: 1 }}
                                    documents={getValues(`ssn_data.application_document_id`) ? [{
                                      id: String(getValues(`ssn_data.application_document_id`)),
                                      source: { sectionKey: "ssn", sourceId: 1 },
                                      documentType: 4,
                                      label: "SSN card",
                                    }] : []}
                                  />
                                  <div className="px-1">
                                    <FilePreview
                                    showReprocess={false}
                                      source_name="ssn"
                                      doc_id={getValues(
                                        `ssn_data.application_document_id`
                                      )}
                                      img={getValues(`ssn_data.file_image`)}
                                      createdAt={ssnCreatedAt}
                                      tag={"delete_document_ssn_document"}
                                      invalidateQueries={"ssnDocData"}
                                      file={getValues(`ssn_data.file`)}
                                      handleClick={() =>
                                        setFilePreview({
                                          ...filePreview,
                                          ssn_id: getValues(
                                            `ssn_data.application_document_id`
                                          ),
                                          ssn_filePath:
                                            (!permissionToViewSSN) ? ssn_masked_placeholder : getValues(`ssn_data.file`),
                                        })
                                      }
                                      handleOnChange={() => {
                                        const isCurrentFile =
                                          filePreview.ssn_filePath ==
                                            getValues(`ssn_data.file_image`)
                                            ? true
                                            : false;

                                        if (isCurrentFile) {
                                          setFilePreview({
                                            ssn_id: "",
                                            ssn_filePath: "",
                                          });
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>
                    {filePreview.ssn_id !== "" && (
                      <div className="col-md-4 col-sm-12 mt-2 ">
                        <CustomPreviewUpload
                          filePath={filePreview.ssn_filePath}
                          docId={filePreview.ssn_id}
                        />
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-md-12 mt-2">
                      <div className="d-flex justify-content-end pt-4 print-hide mb-2">
                        {watch("ssn_data.availableToUpload_ssn") === "Yes" && watch("ssn_data.file") != null && userRole != "applicant"
                          &&
                          <AddDocuverusComment
                            label={userRole === 'applicant' ? `Add Comment` : 'Add/Edit Docuverus Comment'}
                            title={userRole === 'applicant' ? `Add Comment` : 'Add/Edit Docuverus Comment'}
                            defaultValue={
                              userRole == "applicant"
                                ? watch("ssn_data")?.section_comment?.applicant
                                : watch("ssn_data")?.section_comment?.admin
                            }
                            defaultValueInternal={
                              watch("ssn_data")?.InternalComment?.admin
                            }
                            trn_id={trn_id}
                            is_applicant={userRole === 'applicant' ? true : false}
                            document_id={4}
                            tag={'addComment_ssn'}
                            invalidateQueries={'ssnGetidentification'}
                            emp_id={null}
                            role={userRole == 'applicant' ? 'applicant' : userRole}
                          />

                        }

                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {watch(`ssn_data.availableToUpload_ssn`) == "No" && (
              <>
                <div className="row">
                  <div className="col-12">
                    <div className="login-radio-types">
                      <NoDocReasonRadioButtons
                        handleOnchange={() => props.handleAPIDebounced()}
                        options={[
                          {
                            name: "I don't currently have access to document(s), but can provide later",
                            value:
                              "I don't currently have access to document(s), but can provide later",
                          },
                          {
                            name: "I do not have SSN",
                            value: "I do not have SSN",
                          },
                          {
                            value: "other",
                            name: "Other",
                          },
                        ]}
                        source={`ssn_data.no_doc_reason`}
                        section_id={7}
                      />
                      {watch("ssn_data.no_doc_reason") == "other" && (
                        <div>
                          <InputField2
                            label="Please Explain"
                            source={`ssn_data.other_reason`}
                            placeholder="Please Explain"
                            handleOnChange={() => props.handleAPIDebounced()}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <Stack
            sx={{ width: "100%" }}
            style={{ textTransform: "capitalize", marginTop: "10px" }}
            spacing={2}
          >
            <ErrorMessage
              errors={formState.errors}
              name={`ssn_data.file`}
              render={({ message }) => {
                if (message) return <Alert severity="error">{message}</Alert>;

                return <></>;
              }}
            />
          </Stack>
        </div>
        <Dialog
          open={ssnInformation}
          onClose={() => {
            setSnnInformation(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title"></DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Only upload clear, complete, straight documents.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={async () => {
                setSnnInformation(false);
              }}
              autoFocus
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {`Are you sure want to delete document ?`}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Warning! Once deleted cannot revert back .
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpen(false);
              }}
            >
              No
            </Button>
            <Button
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={deleteSSN}
          onClose={() => {
            setDeleteSSN(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {`Are you sure want to delete
           ?`}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Warning! Once deleted cannot revert back .
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <button
              className="btn btn-info text-light"
              onClick={() => {
                setDeleteSSN(false);
              }}
            >
              No
            </button>
            <button
              className="btn btn-info text-light"
              onClick={() => {
                setTimeout(() => {
                  deleteDocumentHandler(
                    watch("ssn_data.application_document_id")
                  );
                }, 200);
              }}
            >
              Yes
            </button>
          </DialogActions>
        </Dialog>
      </>
    </AccordionDetails>
  );
};

export default SsnSection;
